import { Box, Button, Modal, IconButton, Typography } from "@mui/material";
import { useState } from "react";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";
import AdminLogin from "../../components/LoginPage";

const Topbar = () => {
  const [openLogin, setOpenLogin] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem("token")
  );

  // Logout handler
  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      localStorage.clear();
      setIsLoggedIn(false);
    }
  };

  return (
    <>
      {/* TOP BAR */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={2}
      >
        <Box />

        {/* RIGHT SIDE */}
        <Box display="flex" alignItems="center" gap={1.5}>
          {!isLoggedIn ? (
  <Button
    onClick={() => setOpenLogin(true)}
    startIcon={<LoginIcon />}
    sx={{
      background: "linear-gradient(135deg, #4facfe, #00f2fe)",
      color: "#fff",
      textTransform: "none",
      px: 4,
      py: 1.2,
      borderRadius: "12px",
      fontWeight: 600,
      fontSize: "16px", // 🔥 TEXT SIZE INCREASED
      boxShadow: "0 8px 20px rgba(79,172,254,0.4)",
      transition: "all 0.3s ease",
      "&:hover": {
        background: "linear-gradient(135deg, #00f2fe, #4facfe)",
        transform: "translateY(-2px)",
        boxShadow: "0 12px 28px rgba(79,172,254,0.6)",
      },
    }}
  >
    Login
  </Button>
) : (
  <Button
    onClick={handleLogout}
    startIcon={<LogoutIcon />}
    sx={{
      background: "linear-gradient(135deg, #ff416c, #ff4b2b)",
      color: "#fff",
      textTransform: "none",
      px: 4,
      py: 1.2,
      borderRadius: "12px",
      fontWeight: 600,
      fontSize: "16px", // 🔥 TEXT SIZE INCREASED
      boxShadow: "0 8px 20px rgba(255,75,43,0.4)",
      transition: "all 0.3s ease",
      "&:hover": {
        background: "linear-gradient(135deg, #ff4b2b, #ff416c)",
        transform: "translateY(-2px)",
        boxShadow: "0 12px 28px rgba(255,75,43,0.6)",
      },
    }}
  >
    Logout
  </Button>
)}

        </Box>
      </Box>

      {/* LOGIN MODAL */}
      <Modal
        open={openLogin}
        onClose={() => setOpenLogin(false)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "blur(4px)",
        }}
      >
        <Box>
          {openLogin && (
            <AdminLogin closeModal={() => setOpenLogin(false)} />
          )}
        </Box>
      </Modal>
    </>
  );
};

export default Topbar;
